export default {
	exnum_label: '展位号',
	exnum_placeholder: '请输入您的展位号',
  exnum_placeholder_check: '不允许输入特殊字符/?*<>: ',
	type_label: '展位类型',
	type_placeholder: '请选择您的展位类型',
	company_label: '参展商',
	company_placeholder: '请输入参展商公司名称',
	area_label: '展位面积(㎡)',
	area_placeholder: '请输入您的展位面积',
	contact_label: '参展商联系人',
	contact_placeholder: '请输入参展商联系人姓名',
	mobile_label: '电话',
	mobile_placeholder: '请输入您的电话',
	email_label: '邮箱',
	email_placeholder: '请输入您的邮箱',
	email_error: '邮箱格式不正确',
	fax_label: '传真',
	fax_placeholder: '请输入传真',
	remark_label: '备注',
	remark_placeholder: '如有特殊情况，请输入备注',
	tip: '提示',
	choose_booth: '选择展位',
	choose_tip: '在下列展位中，勾选需要缴纳费用的展位',
	special_booth: '特装',
	normal_booth: '标摊',
	add_booth: '添加展位',
	relate_booth: '关联展位',
	relate_tip: '请输入需要关联的展位号',
	special_exhibitor: '特装参展商',
	normal_exhibitor: '标摊参展商',
	relate_btn: '确定',
	close_btn: '关闭',
	add_btn: '确定添加',
	no_booth_err: '系统找不到您的展位',
	no_search_booth_err:'如果没有找到要添加的展位',
	"，可点击":"，可点击",
	prop_title: '展位确认提示',
	prop_sure_pre: '您是否确定',
	prop_sure_after: '是您的展位？',
	bind_success: '绑定展位成功',
	bind_error: '绑定展位失败',
	add_success: '新增展位成功',
	add_error: '新增展位失败',
	add_booth_tip: '手动添加展位提示',
	failed_to_add: '由于展会配置，不可以手动新增展位',
	failed_to_relate: '由于展会配置，不可以手动关联展位',
	"未查询到该展位，请检查展位号后重试": "未查询该展位，请检查展位号后重试",
	"请选择需要缴纳费用的展位，当前已选择": "请选择需要缴纳费用的展位，当前已选择",
	"个": "个",
	"暂无数据，请先添加展位": "暂无数据，请先添加展位",
	"新增展位":"新增展位",
	"已新增展位":"已新增展位",
	"返回上一页":"返回上一页",
	"展位":"展位",
	"已被关联":"已被关联",
	booth_add:"通过展位号添加",
	exhibitors_add:"通过参展公司名称添加",
	next_step:"下一步",
	return:"返回",
	previous:"上一步"
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/chooseBooth.js